import { render, staticRenderFns } from "./BBSelect.vue?vue&type=template&id=6f4231c0"
import script from "./BBSelect.vue?vue&type=script&lang=js"
export * from "./BBSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4231c0')) {
      api.createRecord('6f4231c0', component.options)
    } else {
      api.reload('6f4231c0', component.options)
    }
    module.hot.accept("./BBSelect.vue?vue&type=template&id=6f4231c0", function () {
      api.rerender('6f4231c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBForm/BBSelect.vue"
export default component.exports